const _import = require(`./_import_${
  process.env.NODE_ENV !== 'development' ? 'production' : 'development'
}`);

export default _import;
